import { useMemo, useRef } from "preact/hooks";
import { FloatingPortal } from "../Floating/FloatingPortal.jsx";
import { useAnchoredFloatLayout } from "../Floating/useAnchoredFloatLayout.js";
import "./FloatingActionToolbar.css";

function getActionToolbarScrollContainer(anchorElement) {
  return anchorElement.closest('[data-role="data-grid"], .panel-body, .dashboard-slot.scroll, .fill-area');
}

function buildToolbarWrapperStyle(layout) {
  const style = {
    left: layout.left === null ? "auto" : `${layout.left}px`,
    right: layout.right === null ? "auto" : `${layout.right}px`,
    top: layout.top === null ? "auto" : `${layout.top}px`,
    bottom: layout.bottom === null ? "auto" : `${layout.bottom}px`
  };

  if (layout.width !== null) {
    style.width = `${layout.width}px`;
  }

  return style;
}

export function FloatingActionToolbar({
  actions = [],
  anchorElement = null,
  isOpen = false,
  offset = 1,
  placement = "bottom-start",
  onActionClick
}) {
  const anchorRef = useRef(anchorElement);

  anchorRef.current = anchorElement;

  const visibleActions = useMemo(
    () => actions.filter((action) => action && !action.hidden),
    [actions]
  );
  const layout = useAnchoredFloatLayout({
    anchorRef,
    isOpen: isOpen && Boolean(anchorElement) && visibleActions.length > 0,
    preferredHeight: 44,
    offset,
    placement,
    matchAnchorWidth: false,
    onAnchorInvalidated: null,
    getScrollContainer: getActionToolbarScrollContainer
  });

  if (!isOpen || !layout || visibleActions.length === 0) {
    return null;
  }

  return (
    <FloatingPortal>
      <div
        class={`floating-action-toolbar-wrap${placement === "inline-end" ? " placement-inline-end" : ""}`}
        style={buildToolbarWrapperStyle(layout)}
      >
        <div class="floating-action-toolbar">
          {visibleActions.map((action) => (
            <button
              key={action.key}
              class={`floating-action-toolbar-action${action.selected ? " is-selected" : ""}`}
              onMouseDown={(event) => {
                event.preventDefault();
              }}
              onClick={() => {
                onActionClick?.(action.key);
              }}
              type="button"
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </FloatingPortal>
  );
}
